var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-3"}),_c('div',{staticClass:"col-lg-9 pet-review-back"},[_c('PetReviewModal',{attrs:{"petId":_vm.response.petId}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }